module.exports = __webpack_public_path__ + "static/media/instagram.4a10b4e9.png";